import React from 'react'
import PageCreator from '../../components/PageCreator'
import locationImage from '../../assets/images/location.jpg'
import {Row, Col} from 'react-bootstrap'
import '../../assets/scss/index.scss'

export default function () {
    return (
        <div>
            <PageCreator imageName={locationImage} opacityLevel="0.9">
                <Row>
                <Col md={6} xs={12}>
                    <p className='mainFont' style={{fontSize: '1.3em'}}>Care Hawaii</p><hr />
                    <p className='mainFont' style={{fontSize: '1.2em', marginBottom: '0'}}>Address: 875 Waimanu St<br/>Honolulu, HI 96813</p><br/>
                    <p className='mainFont' style={{fontSize: '1.2em', marginTop: '0', marginBottom: '0'}}><a style={{color: '#000000', textDecoration: 'none'}} href='mailto:info@carehawaii.info'>Email: info@carehawaii.com</a></p>
                    <p className='mainFont' style={{fontSize: '1.2em', marginTop: '0'}}><a style={{color: '#000000', textDecoration: 'none'}} href='tel:808-533-3936'>Phone: (808) 533-3936</a></p>
                </Col>
                <Col md={6} xs={12}>
                    <iframe title="google_maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.2894314168516!2d-157.85669878418108!3d21.299576883851767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c006de2375ef0c9%3A0x5b36d34d62a37c31!2s875%20Waimanu%20St%2C%20Honolulu%2C%20HI%2096813!5e0!3m2!1sen!2sus!4v1602130250217!5m2!1sen!2sus"
                    style={{
                    width: '35vw', minWidth:'250px', maxWidth:'500px', minHeight:'55vh', frameborder:"0", allowfullscreen:"", ariaHidden:"false", tabindex:"0"
                    }}></iframe>
                </Col>
                </Row>
            </PageCreator>
        </div>
    )
}
